var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTitleMaisPremiavel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2381 4.09272L3.98644 19.8482C3.33485 20.4107 3.24052 21.4218 3.77576 22.1065L3.90845 22.2558C4.18995 22.5346 4.56394 22.6926 4.95557 22.6926H8.73024L8.73197 38.7379C8.73197 41.9603 11.2177 44.5725 14.284 44.5725H33.7163L34.0313 44.5633C36.9511 44.3917 39.2684 41.8492 39.2684 38.7379V22.6926H43.0448C43.888 22.6926 44.5716 21.9742 44.5716 21.0881C44.5716 20.6079 44.3669 20.153 44.0139 19.8482L25.7622 4.09272C24.7381 3.20868 23.2622 3.20868 22.2381 4.09272Z",
    fill: "#424242"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTitleMaisPremiavel);
export default __webpack_public_path__ + "static/media/icon-title-mais-premiavel.b36a3fed.svg";
export { ForwardRef as ReactComponent };